(() => {
  const root = document.querySelector('[data-listicle]');
  if (!root) return;

  const params = new URLSearchParams(window.location.search);
  const campaign = new URLSearchParams();
  params.forEach((value, key) => {
    if (key.toLowerCase().startsWith('utm_')) campaign.append(key, value);
  });

  if ([...campaign.keys()].length) {
    root.querySelectorAll('[data-preserve-utm]').forEach((link) => {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      campaign.forEach((value, key) => {
        if (!url.searchParams.has(key)) url.searchParams.append(key, value);
      });
      link.setAttribute('href', url.pathname + url.search + url.hash);
    });
  }

  const bar = root.querySelector('[data-listicle-sticky]');
  const introEnd = root.querySelector('[data-listicle-intro-end]');
  const finalCta = root.querySelector('[data-listicle-final]');
  if (!bar || !introEnd) return;

  let introPassed = false;
  let finalVisible = false;

  const update = () => {
    const show = introPassed && !finalVisible && window.matchMedia('(max-width: 749px)').matches;
    bar.hidden = !show;
  };

  const measure = () => {
    introPassed = introEnd.getBoundingClientRect().bottom < 0;
    if (finalCta) {
      const rect = finalCta.getBoundingClientRect();
      const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
      finalVisible = rect.height > 0 && visibleHeight >= rect.height * 0.4;
    }
    update();
  };

  measure();
  window.addEventListener('scroll', measure, { passive: true });
  window.addEventListener('resize', measure, { passive: true });
})();
